export default __webpack_public_path__ + "static/media/learning_icon_white.799ec615.svg";